/**
 * Calculate Reading Time
 * @param {string} lang - language to translate
 * @param {string} parentClass - parent class that contains children
 * @param {string} childClass - child class is the element that contains the text for calculation
 */
import languages from '../i18n/translations.json';

export default function calculateReadingTime(lang, parentClass, childClass) {
    if (!lang || !parentClass || !childClass) return false;
    const wordsPerMin = 270;
    const charsPerMin = 500;
    const charLang = /(ja|ko|zh)/.test(lang); //CJK based on character count rather than word count)
    const textElementsArray = [];

    // Get tranlation strings from JSON
    const language = languages[lang];
    if (!language) return false;
    if (!language.timeToReadUnderMinute || !language.timeToReadMinutes) return false;

    // Populate text elements array from parent class and child class.
    const parentEle = document.querySelector(`.${parentClass}`);

    if(parentClass) {

        if(parentEle) {
            const children = parentEle.getElementsByClassName(childClass);

            if(children.length > 0) [...children].map((child) => textElementsArray.push(child));
        }
    }

    // Calculate the reading time
    if(!textElementsArray > 0) return false;
    let textLength = 0;

    for (let i = 0; i < textElementsArray.length; i += 1) {
        if (charLang) {
            const count = textElementsArray[i].innerHTML.replace(/<a[^>]*>(.*?)/g, '').length;
            textLength += count;
        } else {
            const count = textElementsArray[i].innerHTML.split(' ').length;
            textLength += count;
        }
    }

    // Build final time + translation string
    let finalString;
    const timeValue = (charLang) ? Math.floor(textLength / charsPerMin) : Math.ceil(textLength / wordsPerMin);

    if (timeValue > 1) {
        finalString = `${language.timeToReadMinutes}`.replace('XX', `${timeValue}`);
    } else {
        finalString = `${language.timeToReadUnderMinute}`;
    }

    return finalString;
}
